import { checkProductInStorage, handleAddToList } from "./api/productUtils";
import { fetchMoreDetails } from "./api/fetchMoreDetails";
import React, { Suspense, useEffect, useState } from "react";
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Box,
  IconButton,
  TextField,
} from "@mui/material";
import { ProductDetails } from "./ProductDetails";
import Loader from "./Loader";
import Product from "./cards/Product";
import isMobile from "./isMobile";

const FilteredData = ({ filteredData, products, setProducts }) => {
  const [open, setOpen] = useState(false);
  const [productDetails, setProductDetails] = useState(null);
  const [quantities, setQuantities] = useState({});
  const mobileView = isMobile();
  const [limit, setLimit] = useState(mobileView ? 10 : 12);
  const [skip, setSkip] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const bottom =
        window.innerHeight + window.scrollY >=
        document.documentElement.scrollHeight - 200;
      if (bottom && !loading && filteredData.length > skip + limit) {
        setLoading(true);
        setTimeout(() => {
          loadMoreProducts();
        }, 300);
      }
    };
    
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [skip, limit]); // Added skip and limit as dependencies to rerun when they change
  console.log(skip, limit)

  const loadMoreProducts = () => {
    // Check if there are more products to load
    const newSkip = skip + limit;
    if (filteredData.length > newSkip) {
      setSkip(newSkip); // Update the skip value
    }
    setLoading(false);
  };

  // Update the quantity for a specific product
  const handleQuantityChange = (productId, action) => {
    setQuantities((prevQuantities) => {
      const currentQuantity = prevQuantities[productId] || 1;
      let newQuantity =
        action === "increment" ? currentQuantity + 1 : currentQuantity - 1;
      newQuantity = Math.max(newQuantity, 1); // Ensure quantity is at least 1
      return { ...prevQuantities, [productId]: newQuantity };
    });
  };

  const handleQuantityInputChange = (productId, value) => {
    setQuantities((prevQuantities) => {
      const newValue = Math.max(1, value); // Ensure quantity is at least 1
      return { ...prevQuantities, [productId]: newValue };
    });
  };
  console.log(filteredData);
  

  return (
    <div>
      <Suspense fallback={<Loader />}>
        <Grid container mb={3} spacing={0.5}>
          {filteredData && filteredData.length > 0 ? (
            filteredData
              .slice(0, skip + limit)
              .map((item) => (
                <Product
                key={`${item.id}-${item.name}`}
                  products={products}
                  setProducts={setProducts}
                  item={item}
                />
              ))
          ) : (
            <Grid item mt={3} xs={12}>
              <Typography variant={mobileView ? "p" : "h6"} style={{ fontWeight: "bold" }} color="text.secondary" align="center">
                No Products Found, Please try something else!
              </Typography>
            </Grid>
          )}
          {loading && <Loader />}
        </Grid>
      </Suspense>
    </div>
  );
};

export default FilteredData;
